import React from 'react';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
type Variant = 'primary' | 'secondary' | 'ghost' | 'danger' | 'inverse' | 'bright';
type Size = 'sm' | 'md' | 'lg';
const base = 'inline-flex items-center justify-center gap-2 rounded-control font-medium transition-[background-color,border-color,color,box-shadow,transform] duration-150 ease-snap focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand disabled:cursor-not-allowed disabled:opacity-50 active:translate-y-px whitespace-nowrap';
const variants: Record<Variant, string> = {
  primary: 'bg-brand text-white hover:bg-brand-hover shadow-card',
  secondary: 'bg-surface text-ink border border-line-strong hover:border-ink-soft hover:bg-canvas',
  ghost: 'text-ink-muted hover:text-ink hover:bg-canvas',
  danger: 'bg-surface text-critical-ink border border-critical-border hover:bg-critical-soft',
  inverse: 'bg-white text-ink hover:bg-canvas shadow-card',
  /* For primary actions sitting on the dark shell, where cobalt goes flat. */
  bright: 'bg-brand-bright text-shell hover:bg-white'
};
const sizes: Record<Size, string> = {
  sm: 'h-8 px-3 text-[13px]',
  md: 'h-10 px-4 text-sm',
  lg: 'h-11 px-5 text-[15px]'
};
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  to?: string;
}
export function Button({
  variant = 'primary',
  size = 'md',
  to,
  className,
  children,
  ...rest
}: ButtonProps) {
  const classes = twMerge(base, variants[variant], sizes[size], className);
  if (to && !rest.disabled) {
    return <Link to={to} className={classes} data-id="element-431" data-mp="1cfhlidohr66i">
        {children}
      </Link>;
  }
  return <button type="button" className={classes} {...rest} data-id="element-432" data-mp="17geo9fer6493">
      {children}
    </button>;
}